import { render, staticRenderFns } from "./ASTApproval.component.html?vue&type=template&id=a2736f84&scoped=true&"
import script from "./ASTApproval.component.ts?vue&type=script&lang=ts&"
export * from "./ASTApproval.component.ts?vue&type=script&lang=ts&"
import style0 from "./ASTApproval.component.scss?vue&type=style&index=0&id=a2736f84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2736f84",
  null
  
)

export default component.exports